import * as type from '../actions/types';

const initialState = {
  isAuthenticated: false,
  profile: {},  // Ensure profile is initially an empty object
  error: null,
  language: null,
  loading: true,  // Start in a loading state
};

const user = (state = initialState, action) => {
  switch (action.type) {
    case type.LOADING:
      return {
        ...state,
        loading: true,
      };
    case type.LOGIN_SUCCESS:
    case type.REGISTER_USER:
      return {
        ...state,
        isAuthenticated: true,
        profile: {
          ...action.payload,
          permissions: action.payload.permissions || [],
        },
        error: null,
        loading: false,
      };
    case type.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
        profile: {},
        loading: false,
      };
    case type.UPDATE_USER:
      return {
        ...state,
        profile: {
          ...action.payload,
          token: action.payload.token || state.profile?.token,
          permissions: action.payload.permissions || [],
        },
        isAuthenticated: true,
        loading: false,
      };
    case type.ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,  // Stop loading on error
      };
    case type.LANGUAGE:
      return {
        ...state,
        language: action.payload,
      };
    default:
      return state;
  }
};

export default user;
